import firebase from 'firebase';
import 'firebase/firestore';

var config = {
  apiKey: "AIzaSyC0PiflzYXGivOmLvjvpb472q7zPdDBxxM",
  authDomain: "mouthguard-club.firebaseapp.com",
  databaseURL: "https://mouthguard-club.firebaseio.com",
  projectId: "mouthguard-club",
  storageBucket: "mouthguard-club.appspot.com",
  messagingSenderId: "759898153617",
  appId: "1:759898153617:web:2d6b2a11c4a2a436341530"
};
firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
// const googleProvider = new firebase.auth.GoogleAuthProvider();
// const facebookProvider = new firebase.auth.FacebookAuthProvider();
const currentUser = auth.currentUser;
const storage = firebase.storage();
const functions = firebase.functions();
const fieldValue = firebase.functions.FieldValue

// date issue fix according to firebase
const settings = {};
db.settings(settings);

// firebase collections

export default {
  db,
  auth,
  functions,
  currentUser,
  fieldValue,
  storage,
  // googleProvider,
  // facebookProvider,
};
